import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'createMapIcon'
})
export class CreateMapIconPipe implements PipeTransform {

  transform(device: any, type: string, showTrainState?: boolean, markOfflineTrain?: boolean): unknown {
      const color = (showTrainState || (markOfflineTrain && (device.alarmState.status === "OFFLINE"))) ? device.alarmState && device.alarmState.background && device.alarmState.background.toLowerCase() : '#28A745';
      const textColor = device && device.alarmState && device.alarmState.textColor || 'black';
      switch (type) {
          case 'train':
              return this.drawShape(color, textColor, device.name, device.mapIconForm);
          case 'host':
             return this.drawShape(color, textColor, device.hostName, 'trapezoid');
      }
  }

   drawShape = (color: string, textColor: string, trainId: string, mapIconForm: string): unknown => {
    let canvas, context;
    let width, height;
    let offset;
    let textWidth, triangleWidth, triangleHeight, triangleY;
    canvas = document.createElement("canvas");
    context = canvas.getContext("2d");

    switch (mapIconForm) {

      case 'rectangular':
            textWidth = context.measureText(trainId);
            width = textWidth.width * 1.5;
            height = 25;
            canvas.width = width + 1;
            canvas.height = height + 15;
            canvas.style.width =`${width}px`;
            canvas.style.height = `${height + 20}px`;
            
            context.clearRect(0,0,width,height);
            context.lineWidth = 0;
            context.fillStyle = color;
            context.strokeStyle = "#000";
            this.drawRect(context, 0, 0, width, height);
            context.fill();
            context.stroke();
            context.fillStyle = textColor;
            context.strokeStyle = color;
            context.font = "12px Arial";
            context.textBaseline  = "top";
            // centre the text.
            context.fillText(trainId,
              Math.floor((width / 2) - (textWidth.width / 1.75)),
              8
            );
            triangleWidth = 5;
            triangleHeight = 10;
            triangleY = canvas.height - triangleWidth ;
            this.drawTriangle(context, canvas.width / 2, triangleY, triangleWidth, triangleHeight, "#000");
            
            return {
              url: canvas.toDataURL(),
  
            }
      
            case 'trapezoid':
              textWidth = context.measureText(trainId);
              width = Math.max(textWidth.width, 15) * 2;
              height = 30;
              canvas.width = width + width/4;
              canvas.height = height + 15;
              canvas.style.width =`${width}px`;
              canvas.style.height = `${height + 20}px`;

              context.clearRect(0,0,width,height);
              context.lineWidth = 0;
              context.fillStyle = color;
              context.strokeStyle = "#000";
              this.drawTrapezoid(context, 0, 0, width, height);
              context.fill();
              context.stroke();
              context.fillStyle = textColor;
              context.strokeStyle = color;
              context.font = "12px Arial";
              context.textBaseline  = "top";
              // centre the text.
              context.fillText(trainId,
                Math.floor((width / 2) - (textWidth.width / 1.75)),
                12
              );
              triangleWidth = 5;
              triangleHeight = 10;
              triangleY = canvas.height - triangleWidth ;
              this.drawTriangle(context, width / 2, triangleY, triangleWidth, triangleHeight, "#000");
              
              return {
                url: canvas.toDataURL(),
    
              }
      default:
          context.font = "25px Arial";
          width = 32;
          height = 42;
          offset = 14;
          const dim = 84;
          canvas.width = dim;
          canvas.height = dim + 20;
          canvas.style.width = "32px";
          canvas.style.height = "42px";
          const centerX = dim / 2;
          const centerY = dim / 2;
          const radius = dim / 2 - 2;
          const startAngle = 0.65 * Math.PI;
          const endAngle = 0.35 * Math.PI;
          context.arc(centerX, centerY, radius, startAngle, endAngle, false);
          context.fillStyle = 'white';
          context.fill();
          context.lineWidth = 1;
          context.strokeStyle = '#000';
          context.closePath();
          context.stroke();
          context.beginPath();
          context.arc(centerX, centerY, radius - 8, 0, 2 * Math.PI, false);
          context.fillStyle = color;
          context.fill();
          context.closePath();
          context.beginPath();
          context.beginPath();
          context.textAlign = 'center';
          context.textBaseline = 'middle';
          context.font = "25px Arial";
          context.fillStyle = textColor;
          context.fillText(trainId, centerX, centerY);
          context.restore();
          context.save();
          context.beginPath();
          context.moveTo(centerX - offset, radius * 2);
          context.lineTo(centerX, radius * 2 + 18);
          context.lineTo(centerX + offset, radius * 2);
          context.fillStyle = 'black';
          context.fill();
          context.lineWidth = 1;
          context.strokeStyle = 'black';
          context.closePath();
          context.stroke();
          context.restore();
          return {
            url: canvas.toDataURL(),
            scaledSize: {
              width,
              height
            }
          }

    }
    
    
  }

  drawRect = (context, x, y, width, height) => {
    const radius = 0;
    context.beginPath();
    context.moveTo(x + radius, y);
    context.lineTo(x + width - radius, y);
    context.quadraticCurveTo(x + width, y, x + width, y + radius);
    context.lineTo(x + width, y + height - radius);
    context.quadraticCurveTo(x + width, y + height, x + width -
    radius, y + height);
    context.lineTo(x + radius, y + height);
    context.quadraticCurveTo(x, y + height, x, y + height - radius);
    context.lineTo(x, y + radius);
    context.quadraticCurveTo(x, y, x + radius, y);
    context.closePath();
  }

  drawTrapezoid = (context, x, y, width, height) => {
    context.beginPath();
    context.moveTo(x + width/4 , y);
    context.lineTo(x + width - width/4, y);
    context.lineTo(x + width, y+ height);
    context.lineTo(x, y+height);
    context.closePath();
  }

  drawTriangle = (context, x, y, triangleWidth, triangleHeight, fillStyle) => {
    context.beginPath();
    context.moveTo(x, y);
    context.lineTo(x + triangleWidth, y - triangleHeight);
    context.lineTo(x - triangleWidth, y - triangleHeight);
    context.closePath();
    context.fillStyle = fillStyle;
    context.fill();
    }

}
